import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Subject } from 'rxjs/Subject';
import { environment } from '../../environments/environment';
import { IBook, IScripture, ITheme } from './interfaces';

export declare interface IListMeta {
  page: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
};

@Injectable()
export class ScripturesService {

  public themes$: Subject<ITheme[]> = new BehaviorSubject(null);
  public books$: Subject<IBook[]> = new BehaviorSubject(null);
  public scriptures$: Subject<IScripture[]> = new BehaviorSubject(null);
  public meta$: Subject<IListMeta> = new Subject();

  constructor( private http: Http ) {}

  selectScripturesAllFetch() {
    return this.scriptures$.asObservable();
  }

  selectThemesAllFetch() {
    return this.themes$.asObservable();
  }


  selectBooksAllFetch() {
    return this.books$.asObservable();
  }

  dispatchScripturesAllFetch( page: number = 1, pageSize: number = 1000, theme?: string, book?: string ): void {
    let url = environment.endPoint + `scriptures?page=${page}&page_size=${pageSize}`;

    if ( theme ) {
      url += '&themeId=' + theme;
    }

    if ( book ) {
      url += '&bookId=' + book;
    }

    this.http.get( url )
    .subscribe( ( response ) => {
      const payload = <IScripture[]>response.json();
      this.scriptures$.next( payload );
      this.meta$.next( JSON.parse( response.headers.get( 'PaginationInfo' ) ) )
    } );
  }

  dispatchThemesAllFetch( page: number = 1, pageSize: number = 1000 ): void {
    const url = environment.endPoint + `scriptures/themes?page=${page}&page_size=${pageSize}`;

    this.http.get( url )
    .subscribe( ( response ) => {
      const payload = <ITheme[]>response.json();
      this.themes$.next( payload );
    } );
  }

  dispatchBooksAllFetch( page: number = 1, pageSize: number = 1000 ): void {
    const url = environment.endPoint + `scriptures/books?page=${page}&page_size=${pageSize}`;

    this.http.get( url )
    .subscribe( ( response ) => {
      const payload = <IBook[]>response.json();
      this.books$.next( payload );
    } );
  }

  selectMeta() {
    return this.meta$;
  }
}



// WEBPACK FOOTER //
// ./src/app/providers/scriptures.service.ts